import { Injectable } from '@angular/core';
import { EntityState, EntityStore, EntityUIStore, StoreConfig } from '@datorama/akita';
import { Alert } from '../../model/alert';
import { decodeFiwareString } from '../../shared/replacer-util';


export interface AlertUI {
  isLoading: boolean;
  visited: boolean;
}
export interface MissionsState extends EntityState<Alert> { }
export interface MissionsUIState extends EntityState<AlertUI> { }


@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'Alert' })
export class MissionsStore extends EntityStore<MissionsState> {
  ui: EntityUIStore<MissionsUIState>;

  constructor() {
    super();
    this.createUIStore().setInitialEntityState({ isLoading: false, visited: false });
  }

  akitaPreAddEntity(entity: Alert) {
    const decodedEntity = decodeEntity(entity);
    return setLocation(decodedEntity);
  }

  akitaPreUpdateEntity(_: Alert, newEntity: Alert) {
    const decodedEntity = decodeEntity(newEntity);
    return setLocation(decodedEntity);
  }
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function decodeEntity(entity: Alert) {
  // Decode Address
  const address = { ...entity.address };

  if (address?.streetAddress) {
    address.streetAddress = decodeFiwareString(address.streetAddress);
  }
  if (address?.addressLocality) {
    address.addressLocality = decodeFiwareString(address.addressLocality);
  }

  const data = { ...entity.data };
  if (entity.data?.alertKeyWord) {
    data.alertKeyWord = decodeFiwareString(entity.data.alertKeyWord);
  }

  const newEntity = { ...entity };
  if (newEntity.description) {
    newEntity.description = decodeFiwareString(entity.description);
  }

  // Decode Object data
  const object = { ...entity.data?.object };
  if (object.objectName) {
    object.objectName = decodeFiwareString(object.objectName);
  }
  if (object.objectNo) {
    object.objectNo = decodeFiwareString(object.objectNo);
  }

  return {
    ...newEntity,
    address,
    data: {
      ...data,
      object
    }
  };
}

function setLocation(entity: Alert) {
  if (!entity.location) {
    entity.location = {
      type: 'Point',
      coordinates: []
    };
  }
  return entity;
}
